
/**
 * 미디어 유형
 */
export type StreamingInfoResponseMediaInfoType = typeof StreamingInfoResponseMediaInfoType[keyof typeof StreamingInfoResponseMediaInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StreamingInfoResponseMediaInfoType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
  AUDIO: 'AUDIO',
  LINK: 'LINK',
} as const;
